<template>
  <v-dialog persistent :value="value" max-width="350px">
    <v-card>
      <v-card-title>
        <span class="text-h5">Remind User?</span>
      </v-card-title>

      <v-divider class="mb-2"/>

      <v-card-text>
        Are you sure you want to send this user a reminder about their account?
        If you click "Send", a reminder <strong>{{ messageType }}</strong> will be sent to 
        <strong>{{ pro_user.contact }}</strong>.
      </v-card-text>

      <v-divider />

      <v-card-actions class="justify-end">
        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="onSend">Send</v-btn>
      </v-card-actions>
    </v-card>
    <ErrorOverlay
      title="Delete User Error" v-model="error_dialog"
      :loading="loading" :message="error_message"
    />
  </v-dialog>
</template>      
 
<script>
import ErrorOverlay from '@/components/pages/ErrorOverlay';
import { mapActions } from "vuex";

export default {
  name: 'ProUserRemindDialog',

  props: ['pro_user', 'value'],

  components: { ErrorOverlay },

  data: () => ({
    // error handling
    loading: false,
    error_dialog: false,
    error_message: "",
  }),

  computed: {
    messageType() {
      return this.pro_user.contact_method === 'phone' ? 'text' : 'email'
    },
  },

  methods: {
    ...mapActions('pro_users', ['remindUser']),

    close() {
      this.$emit('input',false)
    },

    async onSend() {
      let { pro_user } = this

      this.loading = true;
      const result = await this.remindUser( pro_user )
      this.loading = false;

      if (result.ok) {
        this.close()
      } else {
        this.error_dialog = true;
        this.error_message = result.error
      }
    },
  },
};
</script>